export const TAGS_LIST_KEY = 'TAGS_LIST';
export const TAGS_ONE_KEY = 'TAGS_ONE_KEY';

export const TAGS_PROVIDER_LIST_KEY = 'TAGS_PROVIDER_LIST_KEY';
